export default __webpack_public_path__ + "media/bundles/App/report/hero/hero-report-homepage-64e707ccd9efc1c591d1490fa930393d.png";